import { defineMessages } from 'react-intl';

export const i18n: {
	confluenceFilterContributorLabelSelected: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	confluenceFilterContributorLabelUnselected: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	confluenceFilterContributorPlaceholder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	contributor: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	contributor: {
		id: 'dynamic-cards-search-page.filters.names.contributor',
		defaultMessage: 'Contributor',
		description:
			'Text shown as the heading label for the contributor filter on the search page, used to narrow Confluence search results by the person who contributed to content.',
	},
	confluenceFilterContributorPlaceholder: {
		id: 'dynamic-cards-search-page.confluence.filter.contributor.placeholder',
		defaultMessage: 'Find people',
		description: 'Placeholder for contributor filter search input',
	},
	confluenceFilterContributorLabelSelected: {
		id: 'dynamic-cards-search-page.confluence.filter.contributor.label.selected',
		defaultMessage: 'Selected',
		description:
			'Section heading label shown above the list of already-selected contributors in the Confluence contributor filter drop-down on the search page.',
	},
	confluenceFilterContributorLabelUnselected: {
		id: 'dynamic-cards-search-page.confluence.filter.contributor.label.unselected',
		defaultMessage: 'Suggested',
		description:
			'Section heading label shown above the list of suggested contributors not yet selected in the Confluence contributor filter drop-down on the search page.',
	},
});
